export enum WaitingRoomEnum {
  InitGetPosts = 'WaitingRoomEnum_InitGetPosts',
  SuccessGetPosts = 'WaitingRoomEnum_SuccessGetPosts',
  FailGetPosts = 'WaitingRoomEnum_FailGetPosts',

  InitSavePosts = 'WaitingRoomEnum_InitSavePosts',
  SuccessSavePosts = 'WaitingRoomEnum_SuccessSavePosts',
  FailSavePosts = 'WaitingRoomEnum_FailSavePosts',

  CleanAlerts = 'WaitingRoomEnum_CleanAlerts',
}
